import { api } from "./api";
import type { TicketAttachment } from "./dppMutations";

export interface CustomAttribute {
  type: string;
  value: string;
}

export interface MintPassportFields {
  brand: string;
  model: string;
  serialNumber: string;
  department: string;
  eventDate?: string;
  reference?: string;
  name?: string;
  description?: string;
  customAttributes?: CustomAttribute[];
  customerEmail?: string;
  billNumber?: string;
  itemId?: string;
  ticketAttachments?: { ticketId: string; attachmentId: string }[];
  mediaOrder?: string[];
}

export async function mintPassport(
  fields: MintPassportFields,
  images: File[]
): Promise<{ status: string }> {
  const form = new FormData();
  form.append("payload", JSON.stringify(fields));
  for (const image of images) form.append("images", image);

  const { data } = await api.post<{ data: { status: string } }>(
    "/admin/dpps/mint",
    form
  );
  return data.data;
}

export interface DeskTicketSummary {
  id: string;
  ticketNumber: string;
  subject: string;
  status: string;
  createdTime: string;
  contactName: string;
}

export interface DeskTicketDetail {
  ticket: {
    id: string;
    ticketNumber: string;
    subject: string;
    status: string;
    createdTime: string;
    cf: Record<string, string>;
  };
  billNumber: string | null;
  attachments: TicketAttachment[];
}

export async function searchTickets(
  query?: string
): Promise<DeskTicketSummary[]> {
  const params: Record<string, string> = {};
  if (query) params.q = query;
  const { data } = await api.get<{ tickets: DeskTicketSummary[] }>(
    "/admin/tickets",
    { params }
  );
  return data.tickets;
}

export async function getTicket(ticketId: string): Promise<DeskTicketDetail> {
  const { data } = await api.get<DeskTicketDetail>(
    `/admin/tickets/${encodeURIComponent(ticketId)}`
  );
  return data;
}

export interface WatchSuggestion {
  id: string;
  brand: string;
  model: string | null;
  reference: string | null;
  name: string | null;
  year: string | null;
  dialColor: string | null;
  caseMaterial: string | null;
  caseDiameter: string | null;
}

export async function lookupWatchesByReference(
  reference: string
): Promise<WatchSuggestion[]> {
  const { data } = await api.get<{ watches: WatchSuggestion[] }>(
    "/admin/watches",
    { params: { reference } }
  );
  return data.watches;
}

export async function fetchTicketThumbnail(
  ticketId: string,
  attachmentId: string
): Promise<Blob> {
  const { data } = await api.get<Blob>(
    `/admin/tickets/${encodeURIComponent(
      ticketId
    )}/attachments/${encodeURIComponent(attachmentId)}/thumbnail`,
    { responseType: "blob" }
  );
  return data;
}
